import { generatePath, useNavigate } from 'react-router-dom';

import { FormBuilder } from '@components/form-builder';
import { IconJourneyItem } from '@components/icons/journey-icon';
import { useScopedTranslate } from '@locale/translate';

import { useCreateFormTemplate, useCreateFormTemplateImage } from 'api/forms/hooks';
import { useFormBuilderLists } from 'api/lists/hooks';
import { useCurrentWorkspace } from 'ui/authenticated/main/helpers';
import { routePaths } from 'ui/authenticated/navigation';
import { useFeature } from 'ui/hooks';

import { JourneysTabPage } from './journeys-tab';

export const FormTemplatesCreate = () => {
  const navigate = useNavigate();
  const { isEnabled: hasKennitalaEnabled } = useFeature('FEATURE_KENNITALA');
  const { t } = useScopedTranslate(locale);
  const { workspaceId } = useCurrentWorkspace();
  const createTemplate = useCreateFormTemplate();
  const createFormTemplateImageQuery = useCreateFormTemplateImage();
  const { data: lists } = useFormBuilderLists();
  const listPath = generatePath(routePaths.workspaceFormTemplatesList, {
    workspaceId,
  });

  return (
    <FormBuilder
      isCreating
      predefinedOptionsLists={lists}
      backUrl={listPath}
      showKennitala={hasKennitalaEnabled}
      onSave={async (template, onSaveSuccess, createNavigationString = 'form') => {
        const response = await createTemplate.mutateAsync({ ...template, workspace: workspaceId });
        onSaveSuccess?.();
        navigate(
          generatePath(routePaths.workspaceFormTemplatesEdit, {
            workspaceId,
            shortId: response.shortId,
            '*': createNavigationString,
          }),
          { replace: true, state: { from: listPath } }
        );
      }}
      extraTabs={[
        {
          label: t('journeys'),
          section: 'journeys',
          dataTestId: 'formbuilder-journeys',
          content: <JourneysTabPage />,
          icon: <IconJourneyItem />,
          counter: 0,
        },
      ]}
      onImageSave={async (props) => {
        const response = await createFormTemplateImageQuery.mutateAsync(props);
        return response.imageId;
      }}
    />
  );
};

const locale = {
  en: {
    journeys: 'Journeys',
  },
};
